
import escapeHtml from 'escape-html'

import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'

import { AVATAR } from '../../constants.js'
import { useGuestNameStore } from '../../stores/guestName.js'

export default {
	name: 'NewMessageTypingIndicator',
	components: { AvatarWrapper },

	props: {
		/**
		 * The conversation token
		 */
		token: {
			type: String,
			required: true,
		},
	},

	setup() {
		const guestNameStore = useGuestNameStore()
		return { AVATAR, guestNameStore }
	},

	computed: {
		isGuest() {
			return this.$store.getters.isActorGuest()
		},

		externalTypingSignals() {
			return this.$store.getters.externalTypingSignals(this.token)
		},

		typingParticipants() {
			return this.$store.getters.participantsListTyping(this.token)
		},

		visibleParticipants() {
			return this.typingParticipants.slice(0, 3)
		},

		hiddenParticipantsCount() {
			return this.typingParticipants.slice(3).length
		},

		showIndicatorMessage() {
			return this.isGuest
				? !!this.externalTypingSignals.length
				: !!this.typingParticipants.length
		},

		indicatorMessage() {
			if (this.isGuest) {
				return t('spreed', 'Someone is typing …')
			}

			if (!this.typingParticipants) {
				return ''
			}

			const [user1, user2, user3] = this.prepareNamesList()

			if (this.typingParticipants.length === 1) {
				return t('spreed', '{user1} is typing …',
					{ user1 }, undefined, { escape: false })
			}

			if (this.typingParticipants.length === 2) {
				return t('spreed', '{user1} and {user2} are typing …',
					{ user1, user2 }, undefined, { escape: false })
			}

			if (this.typingParticipants.length === 3) {
				return t('spreed', '{user1}, {user2} and {user3} are typing …',
					{ user1, user2, user3 }, undefined, { escape: false })
			}

			return n('spreed', '{user1}, {user2}, {user3} and %n other are typing …',
				'{user1}, {user2}, {user3} and %n others are typing …',
				this.hiddenParticipantsCount, { user1, user2, user3 }, { escape: false })
		},
	},

	methods: {
		prepareNamesList() {
			return this.visibleParticipants.reverse()
				.map(participant => this.getParticipantName(participant))
				.map(name => name ? `<strong>${escapeHtml(name)}</strong>` : undefined)
		},

		// TODO implement model from signaling here
		getParticipantName(participant) {
			if (participant?.displayName) {
				return participant.displayName
			}

			return this.guestNameStore.getGuestName(this.token, participant.actorId)
		},
	},
}
